import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelGender } from "../../functions/Report.ExportGender";
import { formatDataGender } from "../../utils/Report.Format";
import {
  BARCHART,
  SCREENIPAD,
  STYLEHEAD,
  STYLEBODY,
  FLEXDROPDOWN,
} from "../../../../utils/useStyle";

const ReportGender = ({ userDept }) => {
  const [loading, setLoading] = React.useState("");
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = React.useState({
    men: 0,
    women: 0,
    checkTask: [],
  });

  const menPercentage = ((data.men / (data.men + data.women)) * 100).toFixed(1);
  const womenPercentage = (
    (data.women / (data.men + data.women)) *
    100
  ).toFixed(1);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getGenderReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching gender report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const listGender = [
    {
      name: `ชาย (${menPercentage}%)`,
      count: data?.men,
    },
    {
      name: `หญิง (${womenPercentage}%)`,
      count: data?.women,
    },
  ];

  return (
    <>
      <div>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                จำนวนผู้ป่วยเพศชายและเพศหญิง
                <div className={STYLEBODY}>
                  แยกตามปี "{year.label} ตามประเภทสาย "{type.label}"
                </div>
              </div>
              <div className={FLEXDROPDOWN}>
                <FilterYearType
                  year={year}
                  setYear={setYear}
                  type={type}
                  setType={setType}
                />
                <ButtonExcel
                  onClick={() => {
                    ExcelGender(formatDataGender(data), year, type, setLoading);
                  }}
                  loading={loading}
                />
              </div>
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listGender}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="count" fill="#99CC00" label={true} />
              </BarChart>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default ReportGender;
